module.exports = __webpack_public_path__ + "static/media/1001510DO.1bfd3eb8.jpg";